<template>
  <div>
    <div v-if="tableData.length">
      <div class="setTable">
        <loading :isShow="$root.$children[0].isShowLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="mobile1">
            <div class="mobile">
              <span v-if="row.eyeShow">{{ row.mobile || '-' }}</span>
              <span v-else>{{ row.mobile1 || '-' }}</span>
              <a>
                <i
                  class="iconfont iconxianshi eye-icon eye"
                  v-if="row.eyeShow"
                  @click="openEye(row,'eyeShow','mobile',2)"
                ></i>
                <i
                  class="iconfont iconyincang eye-icon eye"
                  v-else
                  @click="openEye(row,'eyeShow','mobile',2)"
                ></i>
              </a>
            </div>
          </template>
          <template slot-scope="{ row }" slot="cardNo1">
            <div class="mobile">
              <span v-if="row.eyeShow1">{{ row.cardNo }}</span>
              <span v-else>{{ row.cardNo1 }}</span>
              <span v-if="row.cardNo1">
                <i
                  class="iconfont iconxianshi eye-icon eye"
                  v-if="row.eyeShow1"
                  @click="openEye(row,'eyeShow1','cardNo',1)"
                ></i>
                <i
                  class="iconfont iconyincang eye-icon eye"
                  v-else
                  @click="openEye(row,'eyeShow1','cardNo',1)"
                ></i>
              </span>
            </div>
          </template>
          <template slot-scope="{ row }" slot="email">
            <div class="email">
              <span v-if="row.eyeShow2">{{ row.email1 }}</span>
              <span v-else>{{ row.email }}</span>
              <span v-if="row.email">
                <i
                  class="iconfont iconxianshi eye-icon eye"
                  v-if="row.eyeShow2"
                  @click="openEye(row,'eyeShow2','email1',4)"
                ></i>
                <i
                  class="iconfont iconyincang eye-icon eye"
                  v-else
                  @click="openEye(row,'eyeShow2','email1',4)"
                ></i>
              </span>
            </div>
          </template>
        </Table>
      </div>

      <div class="pageBox">
        <Page
          :total="total"
          :current="pageNo"
          :page-size="pageSize"
          show-total
          @on-change="pageChange"
          style="text-align: center"
        />
      </div>
    </div>

    <no-data v-if="!tableData.length"></no-data>
  </div>
</template>

<script>
import filter from "@/api/filter";
import { common } from "@/api/mixins";
import { getFamilyInsureRelations } from "../../form/api";

export default {
  name: "detailFamilyInfo",
  props: ["id"],
  mixins: [common],
  data() {
    const _this = this;
    return {
      filter,
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      familyRelations: [],
      columns: [
        {
          title: "序号",
          type: "index",
          align: "center",
          minWidth: 70,
        },
        {
          title: "关系",
          align: "center",
          minWidth: 120,
          render(h, params) {
            const result = params.row.relationShip;
            var str = '';
            _this.familyRelations.map(item=>{
              if(item.value == result) {
                str = item.txt;
              }
            })
            return <span>{str}</span>;
          },
        },
        {
          title: "姓名",
          key: "name",
          minWidth: 110,
          align: "center",
        },
        {
          title: "手机号",
          slot: "mobile1",
          minWidth: 160,
          align: "center",
        },
        {
          title: "性别",
          minWidth: 70,
          align: "center",
          render(h, params) {
            const result = params.row.sex;
            return <span>{filter.filterSex(result)}</span>;
          },
        },
        {
          title: "年龄",
          minWidth: 70,
          align: "center",
          render(h, params) {
            const age = params.row.age;
            return <span>{age || "-"}</span>;
          },
        },
        {
          title: "证件类型",
          minWidth: 120,
          align: "center",
          render(h, params) {
            const result = params.row.cardType;
            return <span>{filter.filterCardType(result)}</span>;
          },
        },
        {
          title: "证件号",
          minWidth: 200,
          align: "center",
          slot:'cardNo1',
        },
        {
          title: "职业",
          minWidth: 120,
          align: "center",
          render(h, params) {
            const profession = params.row.profession;
            return <span>{profession || "-"}</span>;
          },
        },
        {
          title: "归属地",
          minWidth: 220,
          align: "center",
          render(h, params) {
            const area = params.row.area;
            return <span>{area || "-"}</span>;
          },
        },
        {
          title: "电子邮箱",
          minWidth: 220,
          align: "center",
          slot:'email'
        },
      ],
    };
  },

  created() {
    this.queryConfigInsurance();
    this.getInsureList();
  },

  methods: {
    getInsureList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/customerBase/read/family/list",
        type: "POST",
        data: {
          customerId: this.id,
          pageSize: this.pageSize,
          pageNo: this.pageNo,
        },
      })
        .then((res) => {
          this.$root.$children[0].isShowLoading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch(() => {
          this.$root.$children[0].isShowLoading = false;
        });
    },

    // 家庭关系
    async queryConfigInsurance() {
      const { data } = await getFamilyInsureRelations();
      this.familyRelations = data;
    },

    openEye(row,keyName,name,type) {
      if (!row[keyName]) {
        this.descrypt(
          {
            query: row.id,
            operationFunction: 6,
            operationType: type,
          },
          row,
          name
        ).then(() => {
          this.$set(row, keyName, true);
        });
      } else {
        this.$set(row, keyName, false);
      }
    },

    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getInsureList();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .setTable .ivu-table th .ivu-table-cell {
  font-size: 15px;
  font-weight: bold;
  color: #272933;
}

.mobile {
  display: flex;
  align-items: center;
  justify-content: center;
  .eye {
    color: #a8adb7;
  }
}

.pageBox {
  margin-top: 20px;
}
</style>